import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { SettingsProvider } from './context/settingContext';
import { ProductProvider } from './context/productContext';
import { OrdersProvider } from './context/ordersContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SettingsProvider>
        <ProductProvider>
          <OrdersProvider>
            <App />
          </OrdersProvider>
        </ProductProvider>
      </SettingsProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
